import { RoleGuide } from '@regigov/contracts';
import { api } from './client';

export const helpApi = {
  /** The guide for the signed-in user's current role; the API serves no other. */
  mine: () => api('/help/me', RoleGuide),
};
